import { useMemo } from 'react';
import { useScopedOrders } from './useScopedOrders';
import { buildInvoiceNumberMap } from '../utils/invoiceNumber';

/**
 * Loads WooCommerce orders visible to the current user and builds
 * the React-computed invoice number map.
 */
export function useInvoiceNumberMap() {
  const { orders, loading } = useScopedOrders({
    first: 100,
    paginateAll: true,
  });

  const invoiceNumberMap = useMemo(
    () => buildInvoiceNumberMap(orders),
    [orders]
  );

  return { invoiceNumberMap, ready: !loading };
}
